export const SUCCESS = "quote/SUCCESS";
export const ERROR = "quote/ERROR";
export const GET_CURRENT_PLAN = "quote/GET_CURRENT_PLAN";
export const GET_CURRENT_PLAN_ERROR = "GET_CURRENT_PLAN_ERROR";
export const CLEAR_STORE = "CLEAR_STORE";
export const PLACE_ORDER = "PLACE_ORDER";

const initialState = {
  tax: null,
  total: null,
  currentPlan: null,
  jwtSignature: null,
  error: {
    status: null,
    errorMessage: "",
  },
};

// next line is excluded from a sonar because an order of variables is provided by redux
// prettier-ignore
export default (state = initialState, { type, payload }) => { //NOSONAR
  switch (type) {
    case SUCCESS:
      return {
        ...state,
        jwtSignature: payload.jwtSignature,
        tax: payload.priceOutput.calculatedTax,
        total: payload.priceOutput.total,
        error: {
          status: null,
          errorMessage: ""
        }
      };
    case ERROR:
      return { ...state, tax: null, total: null, errors: payload.errors };
    case GET_CURRENT_PLAN:
      return { ...state, currentPlan: payload };
    case GET_CURRENT_PLAN_ERROR:
      return { ...state, error: payload };
    case CLEAR_STORE:
      return {
        ...state,
        tax: null,
        total: null,
        error: {
          status: null,
          errorMessage: ""
        }
      };
    case PLACE_ORDER:
      return state;
    default:
      return state;
  }
};
